import { bcpEventService } from './BcpEventService';
import { cacheService } from './CacheService';

export class CachedBcpEventService {
  constructor() {
    this.eventId = 'Zh1yiB7Qlv06'; // TODO: Make this configurable
  }

  async getTeams(forceRefresh = false) {
    const cacheKey = `bcp_teams_${this.eventId}`;
    
    if (!forceRefresh) {
      const cached = cacheService.getValue(cacheKey);
      if (cached) {
        console.log('Returning teams from cache');
        return cached;
      }
    }
    
    console.log('Fetching teams from API');
    const teams = await bcpEventService.getTeams();
    cacheService.set(cacheKey, teams);
    return teams;
  }

  async getPairings(forceRefresh = false) {
    const cacheKey = `bcp_pairings_${this.eventId}`;
    
    if (!forceRefresh) {
      const cached = cacheService.getValue(cacheKey);
      if (cached) {
        console.log('Returning pairings from cache');
        return cached;
      }
    }
    
    console.log('Fetching pairings from API');
    const pairings = await bcpEventService.getPairings();
    cacheService.set(cacheKey, pairings);
    return pairings;
  }

  async getTeamPairings(round, forceRefresh = false) {
    const cacheKey = `bcp_team_pairings_${this.eventId}_round_${round}`;
    
    if (!forceRefresh) {
      const cached = cacheService.getValue(cacheKey);
      if (cached) {
        console.log(`Returning team pairings for round ${round} from cache`);
        return cached;
      }
    }
    
    console.log(`Fetching team pairings for round ${round} from API`);
    const teamPairings = await bcpEventService.getTeamPairings(round);
    cacheService.set(cacheKey, teamPairings);
    return teamPairings;
  }

  async getEventPlayers(eventId, forceRefresh = false) {
    const cacheKey = `bcp_event_players_${eventId}`;
    
    if (!forceRefresh) {
      const cached = cacheService.getValue(cacheKey);
      if (cached) {
        console.log('Returning event players from cache');
        return cached;
      }
    }
    
    console.log('Fetching event players from API');
    const players = await bcpEventService.getEventPlayers(eventId);
    cacheService.set(cacheKey, players);
    return players;
  }

  async getArmyList(armyId, forceRefresh = false) {
    const cacheKey = `bcp_army_list_${armyId}`;
    
    if (!forceRefresh) {
      const cached = cacheService.getValue(cacheKey);
      if (cached) {
        console.log(`Returning army list ${armyId} from cache`);
        return cached;
      }
    }
    
    console.log(`Fetching army list ${armyId} from API`);
    const armyList = await bcpEventService.getArmyList(armyId);
    cacheService.set(cacheKey, armyList, 60 * 24); // Cache for 24 hours
    return armyList;
  }

  async getEventMetrics(eventId, forceRefresh = false) {
    const cacheKey = `bcp_event_metrics_${eventId}`;
    
    if (!forceRefresh) {
      const cached = cacheService.getValue(cacheKey);
      if (cached) {
        console.log('Returning event metrics from cache');
        return cached;
      }
    }
    
    console.log('Fetching event metrics from API');
    const metrics = await bcpEventService.getEventMetrics(eventId);
    cacheService.set(cacheKey, metrics);
    return metrics;
  }

  getCacheMetadata(dataType) {
    const cacheKeys = {
      teams: `bcp_teams_${this.eventId}`,
      pairings: `bcp_pairings_${this.eventId}`,
    };
    
    const cacheKey = cacheKeys[dataType];
    if (!cacheKey) return null;
    
    const metadata = cacheService.getWithMetadata(cacheKey);
    if (!metadata) return null;
    
    return {
      timestamp: metadata.timestamp,
      formattedTime: cacheService.formatTimestamp(metadata.timestamp),
      hasData: !!metadata.value
    };
  }

  clearCache() {
    cacheService.clearAll();
  }

  clearTeamsCache() {
    cacheService.remove(`bcp_teams_${this.eventId}`);
  }

  clearPairingsCache() {
    cacheService.remove(`bcp_pairings_${this.eventId}`);
    // Also clear all team pairings
    for (let round = 1; round <= 7; round++) {
      cacheService.remove(`bcp_team_pairings_${this.eventId}_round_${round}`);
    }
  }
}

export const cachedBcpEventService = new CachedBcpEventService();